module.exports = __webpack_public_path__ + "780a22fa6cd831690595838371c1a6d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-green-s.png
// module id = 1987
// module chunks = 0